<template>
  <div>
    <SenditTable :headers="tableHeaders" :registers="registers">
      <template #name="{ item }">
        <td>
          {{ item.name }}
        </td>
      </template>
      <template #response="{ item }">
        <td>
          <span style="width: 100px; display: block" class="ellipsis" :title="item.response">
            {{ item.response || '-' }}
          </span>
        </td>
      </template>
      <template #webhooksUrl="{ item }">
        <td>
          {{ item.webhooksUrl || '-' }}
        </td>
      </template>
      <template #isWildcard="{ item }">
        <td class="text-center">
          <input type="checkbox" :checked="item.isWildcard" onClick="return false" />
        </td>
      </template>
      <template #actions="{ item }">
        <td class="text-right">
          <span v-if="!isEnded" @click="clickEdit(item.id)">
            <CIcon
              name="cilPencil"
              size="custom-size"
              :height="22"
              style="cursor: pointer"
              viewBox="0 0 32 32"
              v-c-tooltip="{
                content: $t('settings.twoWay.keywordlist.tooltip.edit'),
                placement: 'botton',
              }"
            />
          </span>
          <span v-if="!isEnded" @click="clickDelete(item.id)">
            <CIcon
              name="cilTrash"
              size="custom-size"
              class="ml-3"
              style="cursor: pointer"
              :height="24"
              viewBox="0 0 32 32"
              v-c-tooltip="{
                content: $t('settings.twoWay.keywordlist.tooltip.delete'),
                placement: 'botton',
              }"
            />
          </span>
        </td>
      </template>
    </SenditTable>
  </div>
</template>

<script>
import SenditTable from '@/components/table/SenditTable.vue'
export default {
  name: 'KeywordList',
  components: {
    SenditTable,
  },
  props: {
    keywordsList: {
      type: Array,
      default: () => [],
    },
    isEnded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickEdit(id) {
      this.$emit('edit-keyword', id)
    },
    clickDelete(id) {
      this.$emit('delete-keyword', id)
    },
  },
  computed: {
    tableHeaders() {
      return [
        { key: 'name', label: this.$t('settings.twoWay.newConfiguration.list.header.keyword'), sorter: true },
        { key: 'response', label: this.$t('settings.twoWay.newConfiguration.list.header.response'), sorter: false },
        { key: 'webhooksUrl', label: this.$t('settings.twoWay.newConfiguration.list.header.endpoint'), sorter: false },
        { key: 'isWildcard', label: this.$t('settings.twoWay.newConfiguration.list.header.wildcard'), sorter: false, _classes: 'text-center' },
        { key: 'actions', label: this.$t('settings.twoWay.numbersList.table.columns.actions'), sorter: false, _classes: 'text-right' },
      ]
    },
    registers() {
      return this.keywordsList
        .filter((el) => !el.isDefault)
        .map((el) => {
          const [response] = el.automaticResponses

          return {
            ...el,
            response: response ? response.text : null,
          }
        })
    },
  },
}
</script>
<style scoped>
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
